import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NothingScheduledControls = ({
  actionTypeBodyInfoKey,
  onScheduleClick
}) => {
  return /*#__PURE__*/_jsx(UIMultiColumn, {
    flush: true,
    children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
      children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        className: "p-x-2",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary",
          onClick: onScheduleClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `baseSchedulingOptionsModal.body.buttons.${actionTypeBodyInfoKey}`
          })
        })
      }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        className: "p-x-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `baseSchedulingOptionsModal.body.nothingScheduled.${actionTypeBodyInfoKey}`
        })
      })]
    })
  });
};
export default NothingScheduledControls;